<template>
<!-- <span> -->
  <svg t="1739872099857" @click.stop="CollectNow(id)"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11594" width="24" height="24"><path d="M800 96a32 32 0 0 1 32 32v743.488a32 32 0 0 1-48.448 27.424L512 736l-271.552 162.912A32 32 0 0 1 192 871.488V128a32 32 0 0 1 32-32h576z m-280.928 117.792a16 16 0 0 0-19.904 4.8l-1.504 2.464-51.52 104.32-115.104 16.736a16 16 0 0 0-10.752 25.12l1.92 2.176 83.264 81.216-19.648 114.656a16 16 0 0 0 20.544 17.952l2.656-1.088L512 528l102.976 54.144a16 16 0 0 0 23.424-13.984l-0.224-2.88-19.648-114.656 83.296-81.216a16 16 0 0 0-6.08-26.624l-2.784-0.64-115.136-16.768-51.488-104.32a16 16 0 0 0-7.264-7.264z" :fill="ori_collect?'#B51520':'#e0e0e0'" p-id="11595"></path></svg>
  <!-- v-if="iconType === 'n2'" -->
  <!-- <a-icon v-else :type="iconType" theme="filled" @click.stop="CollectNow(id)" :style="{color:ori_collect?lightColor:'#e0e0e0',fontSize:size+'px'}"/> -->
<!-- </span> -->
</template>

<script>
export default {
  name: "",
  data() {
    return {
        
    };
  },
  mounted(){
      
  },
  props: {
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    iconType: {
      type: String,
      default: () => {
        return "heart";
      },
    },
    lightColor:{
      type: String,
      default:()=>{
        return '#ff3c00';
      }
    },
    size: {
      type: Number,
      default: () => {
        return 16;
      },
    },
    
  },
  methods: {
	   CollectNow(id){
            let method = "put"
            let showmsg = "已收藏"
            if(this.ori_collect){
                method = "delete"
                showmsg = "已取消收藏"
            }
            this.$axios({url:`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`,method})
			            .then((res) => {
				          if (res.data.errno == 0) {
					          let items = res.data.entities[0].FavoriteApps;
					          this.$store.commit('favoriteReset',items)
					          this.$message.success(showmsg);
				          }else{
					          this.$message.error(res.data.error);
                  }
				        }).catch(function (error) {
					          this.$message.error(error);
			      });
        },

  },
  computed: {
      ori_collect(){
          return this.$store.getters.getFavorites.indexOf(this.id)>-1;
      }
  },
};
</script>
<style>
svg{
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/todoCenter/collect.vue